export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <rect x="76" y="68" width="52" height="20" fill={fill} />
    <rect x="76" y="164" width="52" height="20" fill={fill} />
    <rect x="128" y="100" width="52" height="20" fill={fill} />
    <rect x="76" y="132" width="104" height="20" fill={fill} />
  </>
);
